import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { logger } from 'app/core/util/logger';
import { Observable } from 'rxjs';
import * as fromRoot from '..';
import { FlowsClearFilterAction } from './flows.actions';
import { goAction } from '../router/router.actions';

/**
 * Guard to synchronously clear orders filter & result
 */
@Injectable({ providedIn: 'root' })
export class FlowsExecuteCleanFilterGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug('In FlowsExecuteCleanFilterGuard');
    this.store.dispatch(new FlowsClearFilterAction());
    this.store.dispatch(goAction({ path: 'flows/refresh' }));
    return false;
  }

  getDependencies(): any {
    return [CustomerInfoLoadIfNormalUserGuard, AuthorizationGuard];
  }

  getDependencyRouteData(): any {
    return {
      authorization: 'FLOW.QUERY',
    };
  }
}
